import { TableCell, TableRow } from '@mui/material';
import { formatPersOrgNr } from '../../lib/formatPersnr';
import { formatSynaDate } from '../../lib/formatSynaDate';
import { Ledamot } from '../../model/LedningDto';
import styles from './LedningMember.module.css';
import { RoleList } from './RoleList';

const getUtlandEESText = (value: string) =>
  ({
    J: 'Bosatt utomlands inom EES',
    N: 'Bosatt utomlands utanför EES',
  }[value] || 'Sverige');

export interface LedningMemberProps {
  member: Ledamot;
}

export const LedningMember: React.FC<LedningMemberProps> = ({ member }) => (
  <TableRow className={styles.ledningMember}>
    <TableCell>{member.lednamn}</TableCell>
    <TableCell>
      <RoleList roles={member.funktionslista.funktion} />
    </TableCell>
    <TableCell>{formatPersOrgNr(member.personnr)}</TableCell>
    <TableCell>{formatSynaDate(member.regdatumLedamot.value)}</TableCell>
    <TableCell>{getUtlandEESText(member.utlandEES)}</TableCell>
    <TableCell>{member.antalOvrEnga || '0'}</TableCell>
  </TableRow>
);
